import Vue from 'vue';
import Router from 'vue-router';
import AggregationPage from '@/components/AggregationPage';
import ValuationsPage from '@/components/ValuationsPage';
import AssessmentsPage from '@/components/AssessmentsPage';
import Landingv2 from '@/components/Landingv2';
import PricingPage from '@/components/PricingPage';
import FeaturesPage from '@/components/FeaturesPage';
import TermsOfUsePage from '@/components/TermsOfUsePage';
import PrivacyPolicyPage from '@/components/PrivacyPolicyPage';
import ClosedRegistration from '@/components/ClosedRegistration';

Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Landingv2,
    },
    {
      path: '/aggregation',
      name: 'Data Aggregation',
      component: AggregationPage,
    },
    {
      path: '/valuations',
      name: 'Asset Valuations',
      component: ValuationsPage,
    },
    {
      path: '/assessments',
      name: 'Dynamic Assessments',
      component: AssessmentsPage,
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: PricingPage,
    },
    {
      path: '/features',
      name: 'Features',
      component: FeaturesPage,
    },
    {
      path: '/terms-of-use',
      name: 'Terms of Use',
      component: TermsOfUsePage,
    },
    {
      path: '/privacy-policy',
      name: 'Privacy Policy',
      component: PrivacyPolicyPage,
    },
    {
      path: '/closed-registration',
      name: 'Closed Registration',
      component: ClosedRegistration,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js